export * from './lib/hosted-auth';

export { default as TelegramIcon } from './lib/icon.svg';
export const telegramName = 'Telegram';
